import React from 'react';
import { withTranslation } from 'react-i18next';
import { translate } from '../../utils/util'

const Unauthorized = () => {
    return (
        <div className="center height-total">
            <h1><b>401</b></h1>
            <br />
            <h3>{translate('general.unauthorized')}</h3>
        </div>
    );
}

export default withTranslation()(Unauthorized);
